export const timingEvent = {
    "None": "None",
    "Init": "Init",
    "PreOpen": "PreOpen",
    "Open": "Open",
    "PreClose": "PreClose",
    "Close": "Close",
    "Enquiry": "Enquiry",
    "Down": "Down"
} as const;
export type TimingEvent = (typeof timingEvent)[keyof typeof timingEvent];